import { create } from 'zustand';
import { ANALYSIS_STATUS } from '../data/define';
import { AnalysisResult, SavedThumbnail } from '../data/atom'; // Reuse the interfaces

interface AnalysisStore {
  analysisResult: AnalysisResult;
  aiJobId: number | null;
  savedVideo: File | Blob | string | null;
  savedThumbnail: SavedThumbnail;
  loadingProgress: number;
  abortController: AbortController | null;
  setAnalysisResult: (result: AnalysisResult) => void;
  resetAnalysisResult: () => void;
  setSavedVideo: (video: File | Blob | string | null) => void;
  setSavedThumbnail: (thumbnail: SavedThumbnail) => void;
  setLoadingProgress: (progress: number | ((prev: number) => number)) => void;
  setAbortController: (controller: AbortController | null) => void;
  setAiJobId: (id: number | null) => void;
}

const initialAnalysisResult: AnalysisResult = {
  status: ANALYSIS_STATUS.STANDBY,
  data: null,
  error: null,
  info: null,
};

export const useAnalysisStore = create<AnalysisStore>((set) => ({
  analysisResult: initialAnalysisResult,
  aiJobId: null,
  savedVideo: null,
  savedThumbnail: { thumbnail: null, origCoords: null },
  loadingProgress: 0,
  abortController: null,
  setAnalysisResult: (result) => set({ analysisResult: result }),
  resetAnalysisResult: () => set({ analysisResult: initialAnalysisResult, aiJobId: null }),
  setSavedVideo: (video) => set({ savedVideo: video }),
  setSavedThumbnail: (thumbnail) => set({ savedThumbnail: thumbnail }),
  setLoadingProgress: (progress) =>
    set((state) => ({
      loadingProgress: typeof progress === 'function' ? progress(state.loadingProgress) : progress,
    })),
  setAbortController: (controller) => set({ abortController: controller }),
  setAiJobId: (id) => set({ aiJobId: id }),
}));
